<template>
  <div>
    <hr />
    <div class="row">
      <div class="col-12 bg-secondaryL p-3 my-auto">
        <h4 class="d-inline">Getting Started</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-3">
        <h5>Choose a Transfer Date</h5>
      </div>
    </div>
    <div class="row my-4">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <p class="my-auto">Transfer Date:</p>
          </div>
          <div class="col-8 col-sm-6">
            <el-date-picker
              v-model="transferDate"
              format="dd.MM.yyyy"
              value-format="yyyy-MM-dd"
              class="float-right"
              type="date"
              placeholder="Select a transfer date"
              :clearable="false"
              @change="preFlightCheck"
            ></el-date-picker>
          </div>
          <div
            class="col-2 col-sm-1 text-center"
            v-if="preFlightResponse && eligibleServices && eligibleServices.length > 0"
          >
            <img src="@/assets/img/tick_selector.png" alt="Success" />
          </div>
          <div
            class="col-sm-5 my-auto"
            v-if="preFlightResponse && eligibleServices && eligibleServices.length > 0"
          >
            <p class="my-auto">Success! There's at least one service eligible for transfer.</p>
          </div>
          <div
            class="col-2 col-sm-1 text-center"
            v-if="preFlightResponse && (!eligibleServices || eligibleServices.length == 0)"
          >
            <img src="@/assets/img/cross.png" class="img-fluid" alt="Fail icon" />
          </div>
          <div
            class="col-sm-5 my-auto"
            v-if="preFlightResponse && (!eligibleServices || eligibleServices.length == 0)"
          >
            <p class="my-auto">No services eligible for transfer.</p>
            <!-- Please cancel all bills on or after the requested transfer date in order to proceed.</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="preFlightResponse && eligibleServices && eligibleServices.length > 0">
      <div class="col-lg-12">
        <hr class="my-2" />
        <div class="row">
          <div class="col-12">
            <h5 class="mt-2">Choose Services for Transfer</h5>
            <table v-if="gasServices.length + elecServices.length > 1">
              <tr>
                <div class="col-12 no-pad text-left">
                  <span class="d-inline">
                    <label class="checkbox">
                      <input type="checkbox" @click="selectAll" v-model="allSelected" />
                      <span class="default"></span>
                    </label>
                  </span>
                  <span class="ml-2">Select All</span>
                </div>
              </tr>
            </table>
          </div>
          <div class="col-12" v-if="gasServices.length > 0">
            <!-- <hr> -->
            <h5 class="mt-4">Gas</h5>
            <table class="mb-4">
              <tr v-for="(service, index) in gasServices" :key="index">
                <td>
                  <div class="col-2 no-pad text-left">
                    <span class="d-inline">
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          v-model="transferServices"
                          :value="service"
                          :disabled="!isEligible(service)"
                        />
                        <span class="default"></span>
                      </label>
                    </span>
                  </div>
                </td>
                <td
                  class="pl-2 mb-4"
                  :class="{'text-fade' : !isEligible(service)}"
                >{{service.Service.ServiceIdentifier + ' - ' + service.Site.Address.AddressLines[0]}}</td>
              </tr>
            </table>
          </div>
          <div class="col-12" v-if="elecServices.length > 0">
            <h5 class="mt-4">Electricity</h5>
            <table class="mb-4">
              <tr v-for="(service, index) in elecServices" :key="index">
                <td>
                  <div class="col-2 no-pad text-left">
                    <span class="d-inline">
                      <label class="checkbox">
                        <input
                          type="checkbox"
                          v-model="transferServices"
                          :value="service"
                          :disabled="!isEligible(service)"
                        />
                        <span class="default"></span>
                      </label>
                    </span>
                  </div>
                </td>
                <td
                  class="pl-2 mb-4"
                  :class="{'text-fade' : !isEligible(service)}"
                >{{service.Service.ServiceIdentifier + ' - ' + service.Site.Address.AddressLines[0]}}</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- row close-->
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-hc float-right"
        @click="next"
        :disabled="!preFlightResponse || transferServices.length == 0"
      >
        Next
        <i class="fas fa-caret-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { _ } from 'vue-underscore';
import Vue from 'vue';

export default {
  props: ['save'],
  data() {
    return {
      allSelected: false,
      showServices: false,
    };
  },
  computed: {
    conflictingBills() {
      if (!this.$store.state.finances.bills || !this.transferDate) return [];

      return this.$store.state.finances.bills.filter(
        (b) =>
          b.PeriodEnds > this.transferDate && !(b.IsCancelled || b.IsDeleted)
      );
    },

    preFlightResponse() {
      return this.$store.state.transfer.preFlightResponse;
    },
    isBilled() {
      for (
        let index = 0;
        index < this.preFlightResponse.Services.length;
        index++
      ) {
        if (this.preFlightResponse.Services[index].IsBilled) {
          return true;
        }
        return false;
      }
    },
    transferDate: {
      get() {
        return this.$store.state.transfer.transferDate;
      },
      set(date) {
        this.$store.commit('updateTransferDate', moment.utc(date).format());
      },
    },
    transferServices: {
      get() {
        return this.$store.state.transfer.transferServices;
      },
      set(selected) {
        this.$store.dispatch('setTransferServices', selected);
        this.allSelected = false;
        if (this.transferServices.length == this.eligibleServices.length) {
          this.allSelected = true;
        }
      },
    },
    transferableServices() {
      if (
        this.preFlightResponse &&
        this.preFlightResponse.Services.length > 0
      ) {
        return this.$_.map(this.preFlightResponse.Services, function(service) {
          return service.ServiceIdentifier;
        });
      }
    },
    gasServices() {
      if (
        !this.preFlightResponse ||
        !this.transferableServices ||
        !this.eligibleServices
      )
        return;

      return this.eligibleServices.filter(
        (s) => s.Service.ServiceType === 'Gas'
      );
    },
    elecServices() {
      if (
        !this.preFlightResponse ||
        !this.transferableServices ||
        !this.eligibleServices
      )
        return;

      return this.eligibleServices.filter(
        (s) => s.Service.ServiceType === 'Electricity'
      );
    },
    tenancies() {
      return this.$store.state.contracts.services.flatMap(s=>s.Tenancies)
    },
    eligibleServices() {
      if (this.preFlightResponse && this.transferableServices) {
        return this.preFlightResponse.Services.filter(t=> this.transferableServices.includes(t.ServiceIdentifier)).map(s => {
          const tenancy = this.tenancies.find(t=> t.Id === s.TenancyId);

          return this.$store.state.contracts.services
            .find(s=> s.Service[`${s.Service.ServiceType}Details`].TenancySharedId === tenancy.TenancySharedId)
        })
      }
    },
    bankDetails: {
      get() {
        return this.$store.state.transfer.transferBankDetails;
      },
      set(details) {
        this.$store.commit('updateTransferBankDetails', details);
      },
    },
    serviceTypes() {
      let serviceTypes = [];
      this.transferServices.forEach((service) => {
        serviceTypes.push(service.Service.ServiceType);
      });
      return _.uniq(serviceTypes);
    },
  },
  methods: {
    isEligible(service) {
      return this.transferableServices.includes(
        service.Service.ServiceIdentifier
      );
    },
    setDefaultDdOrganisationId() {
      let regex = '';
      for (let serviceType of this.serviceTypes) {
        regex += serviceType + '|';
      }
      regex = regex.substring(0, regex.length - 1);

      let defaultDdOrganisationId = _.find(
        Vue.config.honeycomb.ddbot.organisations,
        (organisation) => {
          return new RegExp(regex, 'i').test(organisation.name);
        }
      );

      this.bankDetails = {
        AccountName: null,
        AccountNumber: null,
        SortCode: null,
        DdOrganisationId: defaultDdOrganisationId.id,
      };
    },
    next() {
      if (this.isBilled && this.conflictingBills.length) {
        document
          .getElementById('BillBulkDelete')
          .setAttribute('redirected', 'Transfer');
        $('#BillBulkDelete').modal('show');
        $('#Transfer').modal('hide');

        this.$store.commit(
          'updateSelectedBillsforBulkDelete',
          this.conflictingBills
        );
      } else if (this.preFlightResponse && this.transferServices.length != 0) {
        this.setDefaultDdOrganisationId();
        this.$emit('next');
      }
    },
    selectAll() {
      if (!this.allSelected) {
        this.transferServices = this.eligibleServices;
      } else {
        this.transferServices = [];
      }
    },
    preFlightCheck() {
      this.allSelected = false;
      this.$store.state.transfer.transferServices = [];
      this.$store.state.transfer.preFlightResponse = null;
      this.$store
        .dispatch('getPreFlight', this.date)
        .then(() => {
          if (this.eligibleServices.length == 1) {
            this.selectAll();
          }
        })
        .catch((err) => {
          try {
            err.response.data.MoreInformation.forEach((i) => {
              this.$snotify.error(i.Error, {
                timeout: 0,
                closeOnClick: true,
              });
            });
            if (!err.response.data.MoreInformation.length) throw new Error();
          } catch {
            this.$snotify.error('Preflight Check Failed', {
              timeout: 0,
              closeOnClick: true,
            });
          }
        });
    },
  },
};
</script>
